import React from "react";
import BootstrapTable from "react-bootstrap-table-next";
import * as routeName from "../../../routes/routeNameAuthType";

import {columnsLpSub} from "../lpData";
import {useRoute} from "../../../utils/useRoute";
import {NoRecordsFoundMessage, PleaseWaitMessage} from "../../../../_metronic/_helpers";
import { useLanguageForShared } from "../../../../shared/utils/languages/useLanguageForShared";

export function LpSubTable({list = []}) {
  const {t} = useLanguageForShared()

  const {changeRoute} = useRoute();
  const getSelectRow = (props) => {
    return {
      mode: "checkbox",
      clickToSelect: true,
      hideSelectAll: true,
      hideSelectColumn: true,
      onSelect: (row, isSelect, rowIndex, e) => {
        changeRoute(routeName.lpSubDetail,  {id: row?.id})
      },
    };
  }
  return (
    <>
              <BootstrapTable
                wrapperClasses="table-responsive"
                bordered={false}
                classes="table table-head-custom table-vertical-center overflow-hidden"
                bootstrap4
                remote
                hover={true}
                keyField="id"
                data={list}
                columns={columnsLpSub(t)}
                selectRow={getSelectRow({
                  list
                })}
              >
                <PleaseWaitMessage entities={list} />
                <NoRecordsFoundMessage entities={list} />
              </BootstrapTable>
    </>
  );
}
